import { v4 as uuidv4 } from 'uuid';
import { ExpenseDTO, ExpenseFrequency, ExpensesDTO } from '../../api/useExpensesQuery';

export const HEADERS = [
  {
    name: 'Type',
    key: 'type',
  },
  {
    name: '',
    key: 'estimate',
  },
  {
    name: 'Cost',
    key: 'cost',
  },
  {
    name: 'Period',
    key: 'period',
  },
  {
    name: '',
    key: 'actions',
  },
];

export const FIXED_EXPENSES = [
  {
    name: 'Mortgage(s)',
    key: 'MortgageMonthlyTotal',
  },
  {
    name: 'Loan(s)',
    key: 'LoanMonthlyTotal',
  },
  {
    name: 'Insurance(s)',
    key: 'InsuranceMonthlyTotal',
  },
];

export const FREQUENCY_OPTIONS = [
  { label: 'Monthly', value: ExpenseFrequency.Monthly },
  { label: 'Yearly', value: ExpenseFrequency.Yearly },
  { label: 'Recurring', value: null },
];

export const getNewExpense = (): Expense => ({
  isCustom: true,
  Id: uuidv4(),
  Name: '',
  Amount: 0,
  Frequency: ExpenseFrequency.Monthly,
  RepeatForNYears: null,
  RepeatEveryNYears: null,
  Year: null,
  ExpenseOrigin: null,
  Cadence: 'Monthly',
  RecurringAmount: 0,
});

interface Expense extends ExpenseDTO {
  isCustom?: boolean;
}

export interface FormValues {
  expenses: Expense[];
}

export const dataToForm = (data: ExpensesDTO): FormValues => {
  const hardcodedExpenseNames = [...data.HardCodedExpenseNames, 'Other'];
  const customExpenses = data.DetailedExpenses.filter(
    item => !hardcodedExpenseNames.includes(item.Name),
  );

  return {
    expenses: [
      ...hardcodedExpenseNames.map(expenseName => {
        const expense = data.DetailedExpenses.find(item => item.Name === expenseName);

        if (!expense) {
          return {
            ...getNewExpense(),
            Name: expenseName,
            isCustom: false,
          };
        }

        return {
          ...expense,
          Amount: expense.Amount ?? 0,
        };
      }),

      ...customExpenses.map(expense => ({
        ...expense,
        Amount: expense.Amount ?? 0,
        isCustom: true,
      })),
    ],
  };
};
